<a
  target="_blank"
  class="entity-title"
  [class.is-link]="isLink"
  [class.f-width]="fullWidth"
  [class.d-flex]="entityType === TagEntityTypeEnum.Individual"
  [routerLink]="link"
>
  <div class="left">
    @if (isLink) {
      <i [class]="entityTypeIconDictionary[entityType]"></i>
    }

    @switch (entityType) {
      @case (TagEntityTypeEnum.Company) {
        <app-entity-name-number-record
          prefix="ACN: "
          [name]="entity?.['name']"
          [numberFormatted]="(entity?.['entityNumber'] ?? entity?.['acn']) | acn"
        />
      }
      @case (TagEntityTypeEnum.Trust) {
        <app-entity-name-number-record
          prefix="ABN: "
          [name]="entity?.['name']"
          [numberFormatted]="(entity?.['entityNumber'] ?? entity?.['abn']) | abn"
        />
      }
      @case (TagEntityTypeEnum.Individual) {
        <span class="text-gray900">{{ entity?.['fullNameStored'] }}</span>
      }
      @case (TagEntityTypeEnum.CoverLetter) {
        <div class="text-gray900">{{ entity?.['title'] }}</div>
      }
    }

  </div>

  @if (isLink) {
    <div class="right">
      <i class="icon ic-external-link-20"></i>
    </div>
  }
</a>
